import type { WalletStat } from "../../hooks/use-trip-stats";
import { money } from "../../lib/finance";
import { cleanTripAccountName } from "../../lib/trips";
import Avatar from "../../components/Avatar";
import { Private } from "../../components/Privacy";

export interface TripAccountsSpendBarProps {
  walletBalances: WalletStat[];
  tripName?: string;
}

export default function TripAccountsSpendBar({
  walletBalances,
  tripName,
}: TripAccountsSpendBarProps) {
  if (!walletBalances || walletBalances.length === 0) return null;

  return (
    <div className="trip-accounts-spend">
      <div className="trip-accounts-spend-header">
        <span>Account spend</span>
        <small>{walletBalances.length} account{walletBalances.length === 1 ? "" : "s"}</small>
      </div>
      <div className="trip-account-bars-list">
        {walletBalances.map((w) => (
          <div key={w.account.id} className="trip-account-bar-item">
            <div className="trip-account-bar-info">
              <span className="trip-account-bar-name">
                <Avatar owner={w.account.owner} size={15} />
                <strong>{cleanTripAccountName(w.account.name, tripName)}</strong>
              </span>
              <span className="trip-account-bar-amounts">
                <Private><strong>{money(w.spent, w.currency)}</strong></Private>
                <span className="trip-account-bar-slash">/</span>
                <Private><small>{money(w.totalFunds, w.currency)}</small></Private>
                <span className="trip-account-bar-pct">{w.percentSpent}%</span>
              </span>
            </div>
            <div className="budget-bar-track small">
              <div
                className={`budget-bar-fill ${w.percentSpent >= 100 ? "full" : ""}`}
                style={{ width: `${Math.min(100, w.percentSpent)}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
